export const create = (iterable) => new Map(iterable);
export const fromRecord = (record) => {
    return new Map(Object.entries(record));
};
export const copy = (map) => new Map(map);
export const has = (key) => (map) => map.has(key);
export const set = (key, value) => (map) => copy(map).set(key, value);
export const values = (map) => map.values();
export const keys = (map) => map.keys();
export const remove = (key) => (map) => {
    if (!map.has(key)) {
        return map;
    }
    const result = copy(map);
    result.delete(key);
    return result;
};
export const equals = (first, second) => {
    if (first.size !== second.size) {
        return false;
    }
    for (const [key, item] of first.entries()) {
        if (!second.has(key)) {
            return false;
        }
        if (item !== second.get(key)) {
            return false;
        }
    }
    return true;
};
export const size = (set) => set.size;
export const entries = (map) => {
    return map.entries();
};
export const map = (mapFn) => (map) => {
    const result = new Map();
    for (const [key, value] of map.entries()) {
        result.set(key, mapFn(value, key));
    }
    return result;
};
export const filter = (predicate) => (map) => {
    const result = new Map();
    for (const [key, value] of map.entries()) {
        if (predicate(value, key)) {
            result.set(key, value);
        }
    }
    return result;
};
//# sourceMappingURL=Map.js.map